import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Color.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';

function ColorBlock(props) {
  const {
    setColor, color, selectedColor,
  } = props;

  const blockStyles = {
    borderColor: selectedColor === color ? '#000000' : color,
    background: color,
  };

  return (
    <ClickableDiv
      className={styles.block}
      onClick={setColor}
      style={blockStyles}
    />
  );
}

ColorBlock.propTypes = {
  setColor: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  selectedColor: PropTypes.string,
};

export default ColorBlock;
